(function() {
    /* Delay loading of third party scripts
    –––––––––––––––––––––––––––––––––––––––––––––––––– */
    var timeout = 8000;
    if(localStorage.getItem('firstVisit') != null) {
        timeout = 1500;
    } else {
        localStorage.setItem('firstVisit', "true");
    }
    document.addEventListener('DOMContentLoaded', function() {
        document.addEventListener('scroll', loadScripsOnEvent);
        document.addEventListener('mousemove', loadScripsOnEvent);
        document.addEventListener('touchstart', loadScripsOnEvent);
        // fallback so scripts load if no interaction for x time (shorter wait after first visit as many site resources will already be cached)
        setTimeout(function() {
            if (!window.scriptsLoaded) {
                loadScripts();
            }
        }, timeout);
    });
    
    function loadScripsOnEvent(event) {
        if (!window.scriptsLoaded) {
            loadScripts();
            event.currentTarget.removeEventListener(event.type, loadScripsOnEvent);
        }
    }
    
    function loadScripts () {
        if (window.scriptsLoaded) {
            return false;
        }
        window.scriptsLoaded = true;
        loadYotpo();
        loadGorgias();
    }

    function loadYotpo() {
        (function e(){var e=document.createElement("script");e.type="text/javascript",e.defer=true,e.src="//staticw2.yotpo.com/ETIDajzBJCIlmUgIAlLCAEZZbwhUsGKAafMKzJb1/widget.js";var t=document.getElementsByTagName("script")[0];t.parentNode.insertBefore(e,t)})();
    }

    function loadGorgias() {
        if ($('#gorgiasChat').length) {
            // this defers the loading of gorgias by inserting the script after the rest of the page
            // to update the gorgias widget code, replace the code inside the capture tags in /snippets/gorgias.liquid
            var gorgiasCode = decodeURI($('#gorgiasChat').data('gorgias-code')).replace(/(\r\n|\n|\r)/gm, "");
            $('#gorgiasChat').html(gorgiasCode);
        }
    }

})()